/**
 * AppErrorBoundary (Jul-2026, Bugfix „Blackscreen nach Scan-Analyse") —
 * fängt Render-Fehler ab, damit ein einzelner Komponenten-Fehler nie mehr
 * die ganze App in einen schwarzen/leeren Bildschirm reißt.
 */
import { Component } from "react";

export default class AppErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error("AppErrorBoundary:", error, info?.componentStack);
    }

    render() {
        if (!this.state.error) return this.props.children;
        return (
            <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center p-6" data-testid="app-error-boundary">
                <div className="max-w-md w-full bg-white border border-gray-200 rounded-sm shadow-lg p-6 text-center">
                    <div className="text-4xl mb-3">⚠️</div>
                    <h1 className="font-black text-xl text-[#111827]">Da ist etwas schiefgelaufen</h1>
                    <p className="text-sm text-gray-500 mt-2">
                        Die Seite konnte nicht angezeigt werden. Deine Daten sind sicher —
                        bitte lade die Seite neu und versuche es erneut.
                    </p>
                    <p className="text-[10px] text-gray-400 mt-2 font-mono break-all">{String(this.state.error?.message || this.state.error).slice(0, 160)}</p>
                    <button type="button" onClick={() => window.location.reload()}
                        className="mt-4 h-10 px-6 rounded-sm bg-[#111827] text-[#FFCC00] font-bold text-sm hover:bg-black"
                        data-testid="error-boundary-reload">
                        Seite neu laden
                    </button>
                </div>
            </div>
        );
    }
}
